<template>
   <div class="row">
        <div class="col-md-12">
            <div class="card-box">
							
									<p style="text-align: center;">
										<strong>
											<u>Termo de Adesão</u>
										</strong>
									</p>
									<p style="text-align: center;"></p>
									<p style="text-align: center;">
										<strong>
											<u>Ao Instrumento Particular de Contrato de Licença de Uso da Plataforma S.O.S Truck e Outras Avenças</u>
										</strong>
									</p>
									<p style="text-align: center;"></p>
									<strong>
										<u>1. Partes</u>
									</strong>
									<strong>:</strong>
									<br>
										<br>
											<strong>A) Licenciante</strong>
											<br>
												<br>
													<table style="width: 100%; border-color: black; float: left;" border="1" cellspacing="100%">
														<tbody>
															<tr>
																<td colspan="10">
																	<p>
																		<strong>Qualificação</strong>
																	</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>Nome:</strong>
																	</p>
																</td>
																<td colspan="9">
																	<p>
																		<strong>S.O.S Digital Solutions</strong>
																	</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>CNPJ-MF / CPF:</strong>
																	</p>
																</td>
																<td colspan="9">
																	<p>33.843.972/0001-05</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>Endereço:</strong>
																	</p>
																</td>
																<td colspan="6">
																	<p>Praça BR de Itaqui, 211, 23º andar</p>
																</td>
																<td>
																	<p>
																		<strong>Complemento:</strong>
																	</p>
																</td>
																<td colspan="2">
																	<p>sala 2306</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>CEP:</strong>
																	</p>
																</td>
																<td>
																	<p>03310-020</p>
																</td>
																<td>
																	<p>
																		<strong>Bairro:</strong>
																	</p>
																</td>
																<td colspan="2">
																	<p>Vila Gomes Cardim</p>
																</td>
																<td colspan="2">
																	<p>
																		<strong>Cidade:</strong>
																	</p>
																</td>
																<td>
																	<p>São Paulo</p>
																</td>
																<td>
																	<p>
																		<strong>Estado</strong>:
																	</p>
																</td>
																<td>
																	<p>SP</p>
																</td>
															</tr>
															<tr>
																<td colspan="10">
																	<p>
																		<strong>Dados para Contato</strong>
																	</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>Nome:</strong>
																	</p>
																</td>
																<td colspan="3">
																	<p>Gustavo Michelazzo Tambasco</p>
																</td>
															</tr>
															<tr>
																<td>
																	<p>
																		<strong>Telefone:</strong>
																	</p>
																</td>
																<td colspan="3">
																	<p>11 4310-9771</p>
																</td>
																<td colspan="2">
																	<p>
																		<strong>E-mail:</strong>
																	</p>
																</td>
																<td colspan="4">
																	<p>adm@sostruck.com.br</p>
																</td>
															</tr>
														</tbody>
													</table>
													<p>doravante denominado como “
														<u>Licenciante</u>”;
													</p>
													<br>
														<strong>B) Licenciado</strong>
														<br>
															<br>
																<table style="width: 100%; border-color: black; float: left;" border="1" cellspacing="100%" v-if="user.companyUser">
																	<tbody>
																		<tr>
																			<td style="width: 870.5px;" colspan="10">
																				<p>
																					<strong>Qualificação</strong>
																				</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>Nome:</strong>
																				</p>
																			</td>
																			<td style="width: 699.5px;" colspan="9">
																				<p>{{user.companyUser.company.socialName}}</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>CNPJ-MF / CPF:</strong>
																				</p>
																			</td>
																			<td style="width: 699.5px;" colspan="9">
																				<p>{{user.companyUser.company.document}}</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>Endereço:</strong>
																				</p>
																			</td>
																			<td style="width: 325px;" colspan="6">
																				<p>{{user.companyUser.company.address.address + ", " + user.companyUser.company.address.number}}</p>
																			</td>
																			<td style="width: 189px;">
																				<p>
																					<strong>Complemento:</strong>
																				</p>
																			</td>
																			<td style="width: 173.5px;" colspan="2">
																				<p>{{user.companyUser.company.address.complement}}</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>CEP:</strong>
																				</p>
																			</td>
																			<td style="width: 109px;">
																				<p>{{user.companyUser.company.address.cep}}</p>
																			</td>
																			<td style="width: 107px;">
																				<p>
																					<strong>Bairro:</strong>
																				</p>
																			</td>
																			<td style="width: 21.5px;" colspan="2">
																				<p>{{user.companyUser.company.address.neighborhood}}</p>
																			</td>
																			<td style="width: 69.5px;" colspan="2">
																				<p>
																					<strong>Cidade:</strong>
																				</p>
																			</td>
																			<td style="width: 189px;">
																				<p>{{user.companyUser.company.address.city}}</p>
																			</td>
																			<td style="width: 109px;">
																				<p>
																					<strong>Estado</strong>:
																				</p>
																			</td>
																			<td style="width: 58.5px;">
																				<p>{{user.companyUser.company.address.state}}</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 870.5px;" colspan="10">
																				<p>
																					<strong>Dados para Contato</strong>
																				</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>Nome:</strong>
																				</p>
																			</td>
																			<td style="width: 231.5px;" colspan="3">
																				<p>{{user.firstName + " " + user.lastName}}</p>
																			</td>
																		</tr>
																		<tr>
																			<td style="width: 165px;">
																				<p>
																					<strong>Telefone:</strong>
																				</p>
																			</td>
																			<td style="width: 231.5px;" colspan="3">
																				<p>{{user.primaryPhone}}</p>
																			</td>
																			<td style="width: 55px;" colspan="2">
																				<p>
																					<strong>E-mail:</strong>
																				</p>
																			</td>
																			<td style="width: 401px;" colspan="4">
																				<p>{{user.email}}</p>
																			</td>
																		</tr>
																	</tbody>
																</table>
																<p>doravante denominado como “
																	<u>Licenciado</u>”.
																</p>
																<p>Licenciante e Licenciado serão também doravante designados em conjunto como “
																	<u>Partes</u>” e, individualmente e indistintamente, como “
																	<u>Parte</u>”. Termos iniciados em maiúscula não definidos no presente instrumento terão o significado atribuído aos mesmos no Contrato.
																</p>
																<p></p>
																<br>
																	<strong>
																		<u>2. Objeto</u>
																	</strong>
																	<strong>:</strong>
																	<br>
																		<br>
																			<table style="width: 100%; border-color: black; float: left;" border="1" cellspacing="100%">
																				<tbody>
																					<tr>
																						<td colspan="2" width="1209">
																							<p>
																								<strong>Licença de uso da Plataforma S.O.S Truck</strong>
																							</p>
																						</td>
																					</tr>
																					<tr>
																						<td width="302">
																							<p>
																								<strong>Nome da Plataforma:</strong>
																							</p>
																						</td>
																						<td width="907">
																							<p>Plataforma S.O.S Truck.</p>
																						</td>
																					</tr>
																					<tr>
																						<td width="302">
																							<p>
																								<strong>Objeto:</strong>
																							</p>
																						</td>
																						<td width="907">
																							<p>Acesso ao Licenciado à Plataforma S.O.S. Truck para que o Licenciado ofereça certificações para venda.</p>
																						</td>
																					</tr>
																					<tr>
																						<td width="302">
																							<p>
																								<strong>Disponibilização da Plataforma S.O.S Truck:</strong>
																							</p>
																						</td>
																						<td width="907">
																							<p>Em até 5 dias contados da celebração do presente instrumento.</p>
																						</td>
																					</tr>
																					<tr>
																						<td width="302">
																							<p>
																								<strong>Prazo do Contrato:</strong>
																							</p>
																						</td>
																						<td width="907">
																							<p>Enquanto o Licenciado estiver aderido à Plataforma S.O.S Truck, conforme os termos e condições previstos no Contrato.</p>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																			<br>
																				<br>
																					<strong>
																						<u>3. Valores:</u>
																					</strong>
																					<br>
																						<br>
																							<table style="width: 100%; border-color: black; float: left;" border="1" width="100%" cellspacing="100%">
																								<tbody>
																									<tr>
																										<td colspan="4" width="1209">
																											<p>
																												<strong>Custo da Plataforma S.O.S Truck</strong>
																											</p>
																										</td>
																									</tr>
																									<tr>
																										<td width="302">
																											<p>
																												<strong>Valor:</strong>
																											</p>
																										</td>
																										<td width="302">
																											<p>Será cobrado o valor de R$ 14,90 para fins de manutenção da plataforma, que poderá ser negociado junto ao dept. comercial dadas as condições exepcionais da pandêmia de COVID-19.</p>
																										</td>
																										<td width="189">
																											<p>
																												<strong>Modo de pagamento:</strong>
																											</p>
																										</td>
																										<td width="416">
																											<p>boleto bancário OU cartão de crédito.</p>
																										</td>
																									</tr>
																									<tr>
																										<td width="302">
																											<p>
																												<strong>Vencimento:</strong>
																											</p>
																										</td>
																										<td width="302">
																											<p>Primeira mensalidade devida no dia 10 e as demais no mesmo dia dos meses subsequentes.</p>
																										</td>
																										<td width="189">
																											<p>
																												<strong>Penalidade:</strong>
																											</p>
																										</td>
																										<td width="416">
																											<p>Em caso de atraso no pagamento de qualquer montante previsto no Termo de Adesão conforme os termos e condições previstos neste Contrato, incidirão multa no valor de 10% e juros moratórios no valor de 1% ao mês e correção monetária pela variação positiva do IGPM-FGV ou substituto, calculados 
																												<em>pro rata die</em>, sem prejuízo de eventuais perdas e danos incorridos. Na hipótese de o pagamento não ser efetuado em até 5 dias após a data do vencimento respectivo, o Licenciante poderá bloquear o acesso do Licenciado à Plataforma S.O.S Truck, somente reestabelecendo o acesso após a quitação dos valores devidos, sem prejuízo da possibilidade de protesto do título não pago.
																											</p>
																										</td>
																									</tr>
																								</tbody>
																							</table>
																							<!-- <table width="100%" border="1">
																								<tbody>
																									<tr>
																										<td colspan="4" width="1209">
																											<p>
																												<strong>Comiss&atilde;o pela Intermedia&ccedil;&atilde;o</strong>
																											</p>
																										</td>
																									</tr>
																									<tr>
																										<td width="302">
																											<p>
																												<strong>Valor:</strong>
																											</p>
																										</td>
																										<td width="302">
																											<p>Comiss&atilde;o correspondente a 5% do valor da certifica&ccedil;&atilde;o comercializada pelo Licenciado por meio da Plataforma S.O.S Truck.</p>
																										</td>
																										<td width="189">
																											<p>
																												<strong>Modo de pagamento:</strong>
																											</p>
																										</td>
																										<td width="416">
																											<p>boleto banc&aacute;rio OU cart&atilde;o de cr&eacute;dito.</p>
																										</td>
																									</tr>
																									<tr>
																										<td width="302">
																											<p>
																												<strong>Vencimento:</strong>
																											</p>
																										</td>
																										<td width="302">
																											<p>Em at&eacute; 5 dias &uacute;teis contados da data da comercializa&ccedil;&atilde;o da certifica&ccedil;&atilde;o respectiva pelo Licenciado por meio da Plataforma S.O.S Truck.</p>
																										</td>
																										<td width="189">
																											<p>
																												<strong>Penalidade:</strong>
																											</p>
																										</td>
																										<td width="416">
																											<p>Em caso de atraso no pagamento de qualquer montante previsto no Termo de Ades&atilde;o conforme os termos e condi&ccedil;&otilde;es previstos neste Contrato, incidir&atilde;o multa no valor de 10% e juros morat&oacute;rios no valor de 1% ao m&ecirc;s e corre&ccedil;&atilde;o monet&aacute;ria pela varia&ccedil;&atilde;o positiva do IGPM-FGV ou substituto, calculados 
																												<em>pro rata die</em>, sem preju&iacute;zo de eventuais perdas e danos incorridos. Na hip&oacute;tese de o pagamento n&atilde;o ser efetuado em at&eacute; 5 dias ap&oacute;s a data do vencimento respectivo, o Licenciante poder&aacute; bloquear o acesso do Licenciado &agrave; Plataforma S.O.S Truck, somente reestabelecendo o acesso ap&oacute;s a quita&ccedil;&atilde;o dos valores devidos, sem preju&iacute;zo da possibilidade de protesto do t&iacute;tulo n&atilde;o pago.
																											</p>
																										</td>
																									</tr>
																								</tbody>
																							</table> -->
																							<p>Isto posto, as Partes resolvem, pelo presente Termo de Ades&atilde;o ao Instrumento Particular de Contrato de Licen&ccedil;a de Uso da Plataforma S.O.S Truck e Outras Aven&ccedil;as, formalizar a ades&atilde;o do Licenciado ao Instrumento Particular de Contrato de Licen&ccedil;a de Uso da Plataforma S.O.S Truck e Outras Aven&ccedil;as (&ldquo;
																								<u>Contrato</u>&rdquo;), o que se dar&aacute; com o simples &ldquo;clique&rdquo;, pelo Licenciado, no campo &ldquo;ACEITO&rdquo; ao final deste documento, ficando as Partes, assim, automaticamente vinculadas ao Contrato.
																							</p>
																							<p>Isto posto, as Partes resolvem, pelo presente Termo de Adesão ao Instrumento Particular de Contrato de Licença de Uso da Plataforma S.O.S Truck e Outras Avenças, formalizar a adesão do Licenciado ao Instrumento Particular de Contrato de Licença de Uso da Plataforma S.O.S Truck e Outras Avenças (“
																								<u>Contrato</u>”), o que se dará com o simples “clique”, pelo Licenciado, no campo “ACEITO” ao final deste documento, ficando as Partes, assim, automaticamente vinculadas ao Contrato.
																							</p>
																
																					
																					</div>
																				</div>
																			</div>
																		</template>
																		<script>
    export default {
        props: ["dataCompany"],
        watch:{
            'dataCompany'(){
                this.user = this.dataCompany;
                console.log(this.user);
            },
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
                user: {}
            }
        },
        methods: {},
        created() {
        },
        mounted(){
        }
}
</script>

